import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const DeptCategoryForm = ({ maindeptId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [maindeptName, setMainDeptName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.main_dept) {
               setMainDeptName(initialData.main_dept);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!maindeptName.trim()) {
               setError('main dept name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (maindeptId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateMainDeptById/${maindeptId}`;
                    body = { main_dept: maindeptName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createMainDept`;
                    body = { main_dept: maindeptName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(maindeptId ? 'Main Dept updated successfully' : 'Main Dept created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/maindept');
               } else {
                    setError(data.message || `Failed to ${maindeptId ? 'update' : 'create'} MAINDEPT`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };
     const handleCloseModal = () => {
          navigate('/maindept');
     };



     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               {/* <h2 className="section-title">{maindeptName ? 'Edit Main Dept' : 'Add Main Dept'}</h2> */}
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="maindeptName"
                              placeholder=" "
                              autoComplete="off"
                              value={maindeptName}
                              onChange={(e) => setMainDeptName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="maindeptName">Dept Category Name</label>
                    </div>
               </div>
               <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                    {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
                    <button
                         type="submit"
                         className="btn btn-primary"

                         disabled={loading}
                    >
                         {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button
                         type="button"

                         className="btn btn-secondary"
                         onClick={handleCloseModal}
                         disabled={loading}
                    >
                         Cancel
                    </button>
               </div>
          </form>
     );
};

export default DeptCategoryForm;
